import React,{useEffect,useState} from 'react'
import {TextField,Grid, Box,Button} from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DriveUsTwoSchema } from '../../Utils/Validations'
import PhoneInput from 'react-phone-input-2'
import FileValidations from 'Component/FileValidation/FileValidations'
import 'lightbox2/dist/css/lightbox.min.css';
import lightbox from 'lightbox2';
import $ from 'jquery';
const DriveWithUsTwo = ({ handleBack, handleComplete, driveUsData, setDriveUsData }) => {
  const [profile_pic, setProfile_pic] = useState()
  const [vehicle_pic, setvehicle_Pic] = useState()
  const [openImage, setOpenImage] = useState("")
  const [openModal, setOpenModal] = useState(false)
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(DriveUsTwoSchema)
  })
  const {CheckFile,fileError} = FileValidations()
  useEffect(() => {
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true,
    });
    setValue("state", driveUsData.state || "")
    setValue("zip_code", driveUsData.zip_code || "")
  }, [])
  const onSubmit = (data) => {
    console.log(data)
    setDriveUsData((prev) => ({ ...prev, state: data.state, zip_code: data.zip_code,profile_pic: profile_pic,vehicle_pic:vehicle_pic }))
    handleComplete()
  }
  const onChangeFiles = (file, name) => {
    if (!file) {
      console.warn('No file selected');
      return;
    }

    // Use setTimeout to handle file processing asynchronously without blocking the form
    setTimeout(() => {
      try {
        CheckFile(file, name);
        
        if (name === "profile_pic") {
          setProfile_pic(file)
        } else if (name === "vehicle_pic") {
          setvehicle_Pic(file)
        }
      } catch (error) {
        console.error('Error handling file selection:', error);
      }
    }, 50); // Small delay for mobile devices
  }

    const handleOpenModal = (image) => {
        setOpenModal(true)
        setOpenImage(image)
        setTimeout(() => {
          $(document).ready(() => {
            $(`[href="${image}"]`).click();
          });
        }, 0);
      
  
  
    }



  return (
    <div>
         {openModal && (
          <a
            href={`${openImage}`}
            data-lightbox="gallery"
            data-title="Image"
            style={{ display: 'none' }}
          >
            Open Image
          </a>
        )}
        <Grid container  style={{justifyContent:"center",marginTop:20}} >
            <Grid sm={6} xs={12} sx={{textAlign:"left",paddingRight:{sm:1,xs:0}}} >
            <Controller
            control={control}
            name="state"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>State</label>
                <TextField  fullWidth placeholder='State' {...field} error={errors?.state} helperText={errors?.state?.message} />
              </>
            )}
          />
              
        
        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingLeft:{sm:1,xs:0},marginTop:{sm:0,xs:2}}} >
        <Controller
            control={control}
            name="zip_code"
            rules={{ required: true }}
            render={({ field:{onChange,value}}) => (
              <>
                <label>Zip Code</label>
                <TextField   onChange={onChange} value={value}  fullWidth placeholder='Zip code'  error={errors?.zip_code} helperText={errors?.zip_code?.message} />
              </>
            )}
          />

        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 },mt:3 }} >
          <Controller
            control={control}
            name="profile_pic"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
               <label>Profile Picture</label>
                <TextField 
                  fullWidth 
                  type="file" 
                  value={value} 
                  onBlur={onBlur} 
                  inputProps={{ 
                    onChange: async (e) => { 
                      const file = e.target.files?.[0];
                      if (file) {
                        onChange(e); 
                        await onChangeFiles(file, "profile_pic");
                      }
                    },
                    accept: "image/*,.pdf,.doc,.docx"
                  }} 
                  error={errors?.profile_pic || fileError?.profile_pic} 
                  helperText={errors?.profile_pic?.message || fileError?.profile_pic?.message} 
                />
                <span className='image-detail' >Select any file or image</span><br />
                <span className='image-detail' >Maximum file size: 50MB</span>
               
              </>
            )}
          />


        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 },mt:3 }} >
          <Controller
            control={control}
            name="vehicle_pic"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
              <Box>
               <label>Vehicle Picture</label>
               
              </Box>
                <TextField 
                  fullWidth 
                  type="file" 
                  value={value} 
                  onBlur={onBlur} 
                  inputProps={{ 
                    onChange: (e) => { 
                      const file = e.target.files?.[0];
                      if (file) {
                        onChange(e); 
                        onChangeFiles(file, "vehicle_pic");
                      }
                    },
                    accept: "image/*,.pdf,.doc,.docx"
                  }} 
                  error={errors?.vehicle_pic || fileError?.vehicle_pic} 
                  helperText={errors?.vehicle_pic?.message || fileError?.vehicle_pic?.message} 
                />
                <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}} >
                  <Box>
                <span className='image-detail' >Select any file or image</span><br />
                <span className='image-detail' >Maximum file size: 50MB</span>

                  </Box>
                  <img src='/driver_forms/assets/images/VEHICLE PHOTO WITH VISIBLE PLATES EXAMPLE FRONT.png' style={{height:50}} onClick={()=>handleOpenModal("/driver_forms/assets/images/VEHICLE PHOTO WITH VISIBLE PLATES EXAMPLE FRONT.png")}  />
                </Box>
               
              </>
            )}
          />


        </Grid>
        </Grid>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2,pb:2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default DriveWithUsTwo